import type { Song } from 'src/@types/api-types';

import client from 'services/networking/client';
import { SCOPE } from 'shared-types/constants';
import type { LicenseInfo } from 'shared-types/license-info';
import type { UserContext } from 'shared-types/user';
import type { VideoMetadata } from 'shared-types/video-metadata';

export const getSongs = async (
  search: string,
  userContext: UserContext,
  country: string | null,
): Promise<Song[] | undefined> => {
  const countryQuery = country ? `&country=${country}` : '';
  const url = `/songs?search=${search}&userContext=${userContext}${countryQuery}`;
  const isSearchEmpty = search.length !== 0;

  return isSearchEmpty ? await client.get(url) : undefined;
};

export const getSong = async (id: string): Promise<Song> => {
  const response = await client.get(`/songs/${id}`);
  return response;
};

export const getSongsFromBamIds = async (bamIds: string[]): Promise<Song[]> => {
  const response = await client.post('/songs/bamIds', { bamIds });
  return response;
};

export const getSongFromBamId = async (bamId: string): Promise<Song> => {
  const response = await client.post('/songs/bamId', { bamId });
  return response;
};

export const getB2cVideoMetadata = async (licenseInfo: LicenseInfo): Promise<VideoMetadata> => {
  return client.post('/video-metadata/b2c', licenseInfo);
};

export const getB2bVideoMetadata = async (licenseInfo: LicenseInfo): Promise<VideoMetadata> => {
  return client.post(`/video-metadata?scope=${SCOPE.B2B}`, licenseInfo);
};

export const sendSongsSuggestion = async (suggestion: string): Promise<boolean> => {
  return client.get(`/no-match-search/suggestion?query=${suggestion}`);
};

export const getWaitingSongs = async (): Promise<Song[]> => {
  return client.post('/songs/waitingSongs', {});
};
